<template>
  <div class="table-responsive">
    <!-------------------- Tabla de REsultados -------------------->
    <div
      aria-hidden="true"
      class="onboarding-modal modal fade animated"
      id="modalAdddevolucionNew"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog modal-lg modal-centered" role="document">
        <div class="modal-content text-center">
          <button
            aria-label="Close"
            class="close"
            data-dismiss="modal"
            type="button"
          >
            <span class="close-label">Cancelar</span>
            <span class="os-icon os-icon-close"></span>
          </button>
          <div class="onboarding">
            <div class="onboarding-content with-gradient">
              <div class="text-center">
                <h4 class="onboarding-title text-center">Elije la factura</h4>
              </div>
              <form>
                <div class="row">
                  <div class="col-md-12">
                    <table class="table table-hover">
                      <thead>
                        <tr>
                          <th></th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="det in dataTabla"
                          v-bind:key="det.id"
                          @click="rowClick(det)"
                        >
                          <td>
                            <div class="value">
                              <div class="font-weight-bold">
                                #&nbsp;{{ det.numero }}
                              </div>
                            </div>
                            <div>
                              <span
                                style="font-weight: bold"
                                class="font-weight-bold"
                                >Serie:</span
                              >&nbsp;{{ det.cargo_serie.serie }}
                            </div>
                            <div>{{ det.tienda.nombre }}</div>
                          </td>
                          <td>
                            <div class="badge badge-dark">
                              {{ det.estado_str }}
                            </div>
                            <div class="sub-value">
                              <small>
                                {{ det.cliente_nit }} -
                                {{ det.cliente_nombre }}</small
                              >
                            </div>
                            <div>
                              <span
                                style="font-weight: bold"
                                class="font-weight-bold"
                                >Total:</span
                              >
                              {{ det.valor_total }}
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      aria-hidden="true"
      class="modal fade"
      id="modalAdddevolucion"
      role="dialog"
      tabindex="-1"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header faded smaller">
            <h5 class="modal-title">Devoluciones</h5>
            <button
              aria-label="Close"
              class="close"
              data-dismiss="modal"
              type="button"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-sm-12 col-md-12">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger': current.errors && current.errors.caja,
                      }"
                      >Caja</label
                    >
                    <select
                      class="form-control"
                      autofocus="autofocus"
                      v-model="current.caja"
                      @change="refreshCaja"
                      :disabled="true"
                      @input="$emit('input', $event.target.value)"
                    >
                      <option v-for="(c, key) in caja" :value="c.id" :key="key">
                        Caja: {{ c.caja }} - Tienda {{ c.tienda.nombre }}
                      </option>
                    </select>
                    <small
                      v-if="current.errors && current.errors.caja"
                      class="form-text text-danger"
                      >{{ current.errors.caja }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-12">
                  <div class="form-group">
                    <label>Observación</label>
                    <textarea
                      v-model="current.observacion"
                      class="form-control"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.observacion"
                      class="form-text text-danger"
                      >{{ current.errors.observacion[0] }}</small
                    >
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              class="btn btn-primary"
              @click="guardarDevolucion"
              type="button"
            >
              Agregar
            </button>
            <button
              class="btn btn-secondary"
              ref="cerrarModalDetalle"
              data-dismiss="modal"
              type="button"
            >
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import PaginationComponent from "@/components/utils/PaginationComponent";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import CargosService from "@/services/cxc/CargosService";
import DevolucionesService from "@/services/inventario/DevolucionesService";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  props: ["dataTabla"],
  components: {
    PaginationComponent,
    UsuarioEnTablaComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      current: {
        errors: {
          observacion: "",
        },
      },
      errors: "",
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "",
    };
  },
  computed: {
    ...mapGetters({
      caja: "cargos/caja",
    }),
  },
  mounted() {},
  methods: {
    rowClick(current) {
      let self = this;
      self.current.cargo_id = current.id;
      self.current.caja = current.pedido_e.caja;
      self.refreshCaja();
      $("#modalAdddevolucion").modal();
    },
    guardarDevolucion(e) {
      e.preventDefault();
      let self = this;
      let current = Object.assign({}, self.current);
      console.log(current);
      CargosService.getById(current.cargo_id).then((response) => {
        self.current.cargo_d = response.data.cxccargod_set;
      });
      DevolucionesService.save(current)
        .then((response) => {
          $("#modalAdddevolucion").modal("hide");
          $("#modalAdddevolucionNew").modal("hide");
          setTimeout(function () {
            self.$router.push({
              name: "wms-envio-devolucion-mayoreo-editar",
              params: { id: response.data.id },
            });
            self.refreshCurrent();
          }, 2000);
        })
        .catch((error) => {
          self.current.errors = error.response.data;
          if (self.current.errors.devolucion_cliente) {
            Notifications.alert.error(
              "Error",
              self.current.errors.devolucion_cliente
            );
          }
        });
    },
    refreshCaja() {
      let self = this;
      self.$store.dispatch("cargos/caja", {
        activa: true,
        quitar_paginacion: true,
      });
    },
    rowClickDevolucion() {
      let self = this;
      self.$router.push({
        name: "inventario-devoluciones-nuevo",
        params: { cargo: current.id },
      });
    },
    onPageChange(page) {
      this.currentPage = page;
      this.$store.dispatch("cargos/fetch", {
        page: page,
        "filter[search]": this.$data.searchtext,
      });
    },
  },
};
</script>
